<dx-popup
    #dashboardCreator
    title="Workspace Configuration"
    [showTitle]="true"
    [minWidth]="'80%'"
    [minHeight]="'85%'"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'">
        <dx-box #dashboardBox width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto" class="content-holder">
                <dx-form #dashboardForm width="100%" [colCount]="80" [formData]="dashboard">
                    <dxi-item dataField="name" editorType="dxTextBox" [colSpan]="15">
                        <dxi-validation-rule type="required" message="Name is required"></dxi-validation-rule>
                        <dxi-validation-rule
                            type="async"
                            message="Workspace with same name exists"
                            [validationCallback]="uniqueNameValidation"
                        ></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="isDefault" editorType="dxCheckBox" [colSpan]="6">
                        <dxo-label text="Default"></dxo-label>
                    </dxi-item>
                    <dxi-item
                        dataField="isSystem"
                        editorType="dxCheckBox"
                        [colSpan]="6"
                        [visible]="systemAllowed"
                        [editorOptions]="{ onValueChanged: onSystemFlagChanged() }"
                    >
                        <dxo-label text="System"></dxo-label>
                    </dxi-item>
                    <dxi-item
                        dataField="allowExternalUsers"
                        editorType="dxCheckBox"
                        [editorOptions]="{ disabled: !dashboard.isSystem }"
                        [colSpan]="8"
                        [visible]="systemAllowed"
                    >
                        <dxo-label text="External Users"></dxo-label>
                    </dxi-item>
                    <dxi-item
                        dataField="isShared"
                        editorType="dxCheckBox"
                        [editorOptions]="{
                            value: dashboard.isShared || dashboard.isSystem
                        }"
                        [colSpan]="8"
                        [visible]="systemAllowed"
                    >
                        <dxo-label text="Internal Shared"></dxo-label>
                    </dxi-item>
                    <dxi-item dataField="autoFitView" editorType="dxCheckBox" [colSpan]="8">
                        <dxo-label
                            [text]="dashboard.viewMode === 'Scroll' ? 'Auto Fit to Width' : 'Auto Fit to View'"
                        ></dxo-label>
                    </dxi-item>
                    <dxi-item itemType="empty" [colSpan]="sharingAllowed || systemAllowed ? 1 : 17"></dxi-item>
                    <dxi-item
                        dataField="viewMode"
                        editorType="dxSelectBox"
                        [editorOptions]="{
                            items: dashboardViewModes,
                            onValueChanged: onViewModeChange
                        }"
                        [colSpan]="15"
                    >
                        <dxo-label text="View Mode"></dxo-label>
                        <dxi-validation-rule type="required" message="View Mode is required"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item
                        dataField="noOfSections"
                        editorType="dxNumberBox"
                        [editorOptions]="{
                            min: 1,
                            max: 5,
                            showSpinButtons: true,
                            onValueChanged: onSectionCountChange
                        }"
                        [colSpan]="12"
                    >
                        <dxo-label text="No of Sections"></dxo-label>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item [ratio]="1" class="content-holder">
                <ng-container *ngIf="dashboard?.viewMode === 'Carousel'">
                    <dx-multi-view
                        width="100%"
                        height="100%"
                        [(selectedIndex)]="multiViewIndex"
                        [dataSource]="dashboard?.dashboardSections"
                        [loop]="false"
                        [swipeEnabled]="false"
                        [animationEnabled]="true"
                        [deferRendering]="false"
                    >
                        <div
                            *dxTemplate="let section of 'item'"
                            class="multiview-content dx-theme-accent-as-border-color"
                        >
                            <ng-container
                                [ngTemplateOutlet]="sectionBoxTemplate"
                                [ngTemplateOutletContext]="{ data: section }"
                            ></ng-container>
                        </div>
                    </dx-multi-view>
                </ng-container>
                <ng-container *ngIf="dashboard?.viewMode === 'Scroll'">
                    <dx-scroll-view #scrollView width="100%" height="100%">
                        <dx-box *ngIf="sectionHeight > 0" width="100%" height="100%" direction="col">
                            <ng-container *ngFor="let section of dashboard?.dashboardSections; let idx = index">
                                <dxi-item [baseSize]="sectionHeight">
                                    <div
                                        *dxTemplate
                                        [attr.id]="'section-' + idx"
                                        class="scrollview-content dx-theme-accent-as-border-color"
                                    >
                                        <ng-container
                                            [ngTemplateOutlet]="sectionBoxTemplate"
                                            [ngTemplateOutletContext]="{ data: section }"
                                        ></ng-container>
                                    </div>
                                </dxi-item>
                            </ng-container>
                        </dx-box>
                    </dx-scroll-view>
                </ng-container>
            </dxi-item>
            <dxi-item baseSize="auto" class="content-holder">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                [icon]="iconCancel"
                                text="Cancel"
                                type="default"
                                (onClick)="onCancelClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <ng-container *ngIf="dashboard?.noOfSections > 1 && dashboard?.viewMode === 'Carousel'">
                        <dxi-item
                            *ngFor="let section of dashboard?.dashboardSections; let idx = index"
                            location="center"
                        >
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    stylingMode="text"
                                    [icon]="multiViewIndex === idx ? 'fas fa-circle' : 'far fa-circle'"
                                    (onClick)="onCarouselViewNavigationClick(idx)"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </ng-container>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                [icon]="iconSave"
                                text="Save"
                                type="success"
                                (onClick)="onSaveClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<ng-template #sectionBoxTemplate let-section="data">
    <dx-box width="100%" height="100%" direction="col">
        <dxi-item baseSize="auto" class="content-holder">
            <dx-form #sectionForm width="100%" [colCount]="76" [(formData)]="section">
                <dxi-item
                    dataField="layout"
                    editorType="dxSelectBox"
                    [isRequired]="true"
                    [editorOptions]="{
                        elementAttr: { section: section },
                        displayExpr: 'text',
                        valueExpr: 'id',
                        items: dashboardLayouts,
                        onValueChanged: onLayoutChange
                    }"
                    [colSpan]="15"
                >
                    <dxo-label [text]="dashboard?.viewMode === 'Scroll' ? 'No of Columns' : 'Layout'"></dxo-label>
                    <dxi-validation-rule
                        type="async"
                        message="Invalid value"
                        [validationCallback]="validLayoutValidation"
                    ></dxi-validation-rule>
                </dxi-item>
                <dxi-item itemType="empty" [colSpan]="59"></dxi-item>
                <dxi-item
                    itemType="button"
                    horizontalAlignment="right"
                    verticalAlignment="center"
                    [buttonOptions]="{
                        type: 'normal',
                        elementAttr: { section: section },
                        stylingMode: 'text',
                        icon: 'fas fa-undo',
                        hint: 'Reset Layout',
                        width: 24,
                        onClick: onResetLayout
                    }"
                    [colSpan]="2"
                ></dxi-item>
            </dx-form>
        </dxi-item>
        <dxi-item [ratio]="1">
            <div *dxTemplate class="content-holder">
                <app-dynamic-dashboard
                    [editMode]="true"
                    [dashboardItems]="section?.dashboardItems"
                    [direction]="section?.direction"
                    [layout]="section?.layout"
                    [viewMode]="dashboard.viewMode"
                ></app-dynamic-dashboard>
            </div>
        </dxi-item>
    </dx-box>
</ng-template>
